import { Component } from '@angular/core';
import { UserService } from 'src/app/security/services/user.service';
import { AnalystRoleEnum } from '@compumark/analyst-selection-tool-client';

@Component({
  selector: 'app-admin-link',
  standalone: false,
  templateUrl: './admin-link.component.html',
  styleUrls: ['./admin-link.component.scss'],
})
export class AdminLinkComponent {
  constructor(private service: UserService) {}

  isAdmin(): boolean {
    return (
      !!this.service.getCurrentUser() &&
      !!this.service
        .getCurrentUser()
        .roles?.find((r) => r === AnalystRoleEnum.ADMIN)
    );
  }

  isQualityAnalyst(): boolean {
    return (
      !!this.service.getCurrentUser() &&
      !!this.service
        .getCurrentUser()
        .roles?.includes(AnalystRoleEnum.QUALITY_ANALYST)
    );
  }
}
